import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 The 360° Injury Rehab System™ (6 Volumes, 150+ pages)',
  price: '$19'
}, {
  label: '🎁 Bonus #1: M.A.P.A. Mobility Flow™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: The Zero-Equipment Home Guide™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: The Load Master Protocol™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: The A.R.M.A. Preventive Shield™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: The Performance Warm-up Matrix™',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-192" data-mp="1tgekc26d7sus">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-193" data-mp="1ohbck9z038j4">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-194" data-mp="236r0li75czv4">
          🚀 Start Managing Injuries Confidently In 30 Days
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-195" data-mp="2c5kydbw7rwa9">
          Assess properly, prescribe progressively and return athletes to sport safely. One single
          payment, lifetime access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-196" data-mp="2m3il1uyfdl0r">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-197" data-mp="2h5qqet6ebksv">
            <span data-id="element-198" data-mp="mrfzmf68qgkg">What's included</span>
            <span data-id="element-199" data-mp="msheyvuahp7z">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-200" data-mp="2mtpfukjrrfbu">
              <span className="text-plum/80" data-id="element-201" data-mp="2rt21x32tgidd">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-202" data-mp="2vtcg330rif3b">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-203" data-mp="35sa0puv2hoh1">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-204" data-mp="3ar4q5fnjiba4">
              Real total value: <span className="text-plum/40 line-through" data-id="element-205" data-mp="3fhl6b7iqwb06">$216</span>
            </span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-206" data-mp="3jj6on8e1thhr">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-207" data-mp="3ojaxcc8pt7xf">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "40px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-208" data-mp="7h6ovtnixv7w">
                  $
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "70px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-209" data-mp="3po4i11k26fgm">
                  19
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-210" data-mp="geqsvacru5m7">
                  USD
                </span>
              </span>
            </div>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-211" data-mp="omtjxi48xzeo">
              One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-212" data-mp="fnq0gd163hzn">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-213" data-mp="jread2d9upo2">
          <CTAButton data-id="element-214" data-mp="17fxgpccrgsdi">Get The 360° Injury Rehab System</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-215" data-mp="1ceii3f3r1i3j">
          You save $197 USD (91% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-216" data-mp="ym2law1fygb2">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-217" data-mp="1qcp8692gidsn">
              <Icon className="h-4 w-4 text-grape" data-id="element-218" data-mp="1v507patabxko" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}